module.exports = __webpack_public_path__ + "img/rewise-logo.bc0ca67f.png";